// The finder is a separately deployed app, so callers must enter it with a full-document navigation
// — a Router hop 404s against the public route table.
const FINDER_BASE_PATH = '/beta/find-an-agent';

// Spelled out rather than built from SELLER_FLOW_PATHS: importing the flow's domain here would put
// every public-app project downstream of it, so a seller-flow model edit would rebuild and redeploy
// the SSR public app and landing-pages. seller-flow.routes.spec.ts holds these to the route table
// instead, which costs nothing.

/** For an entry point that knows nothing about the seller — the flow asks for the suburb first. */
export const FINDER_START_PATH = `${FINDER_BASE_PATH}/suburb`;

/** For an entry point that already knows the suburb, which is what lets it skip the suburb step. */
export const FINDER_ENTRY_PATH = `${FINDER_BASE_PATH}/sold-nearby`;

// Primitives rather than a LocationDetails, so the entry points can share this without each of them
// having to resolve that model.
export interface FinderEntryLocation {
  locationId: number;
  locationType: string;
  localityName: string;
}

// Nothing beyond these three is worth adding: the finder rebuilds its URL from a fixed nine-key
// allowlist on every step transition, so any extra parameter is dropped after the landing step.
export function buildFinderEntryUrl(location: FinderEntryLocation): string {
  const params = new URLSearchParams({
    locationId: String(location.locationId),
    locationType: location.locationType,
    localityName: location.localityName,
  });

  return `${FINDER_ENTRY_PATH}?${params.toString()}`;
}
